import { Text } from '@mantine/core';
import { FormattedMessage, useIntl } from 'react-intl';

import { UsageSummary } from '../../purchase-shipment-volume/usage-summary';

import type { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';

type UsageOverviewProps = {
  bodyMessage: MessageDescriptor;
  planName: string;
  shipmentLimit: number;
  totalUsage: number;
  usagePercentage: number;
  isAtLimit: boolean;
  isHighLimitWarning: boolean;
  isMediumLimitWarning: boolean;
};

export const UsageOverview = ({
  bodyMessage,
  planName,
  shipmentLimit,
  totalUsage,
  usagePercentage,
  isAtLimit,
  isHighLimitWarning,
  isMediumLimitWarning,
}: UsageOverviewProps) => {
  const intl = useIntl();

  return (
    <>
      <Text size='sm'>
        <FormattedMessage
          {...bodyMessage}
          values={{
            b: (chunks: ReactNode) => <b>{chunks}</b>,
            percentage: usagePercentage,
            shipmentLimit: intl.formatNumber(shipmentLimit),
            totalUsage: intl.formatNumber(totalUsage),
          }}
        />
      </Text>
      <UsageSummary
        isHighLimitWarning={isHighLimitWarning}
        isMediumLimitWarning={isMediumLimitWarning}
        isAtLimit={isAtLimit}
        planName={planName}
        shipmentLimit={shipmentLimit}
        totalUsage={totalUsage}
      />
    </>
  );
};
